import { Task } from '../categories'

const task1: Task = {
  id: 'sql-create-table',
  categoryId: '6',
  title: 'create table',
  code: `CREATE TABLE students (
  student_id int,
  last_name varchar(255),
  first_name varchar(255),
  local_address varchar(255),
  home_of_record varchar(255),
  major varchar(255),
  overall_gpa decimal(3,2)
);`,
  lang: 'sql',
}

const task2: Task = {
  id: 'sql-window-functions',
  categoryId: '6',
  title: 'window functions',
  code: `SELECT quarter,
  month,
  sales,
  SUM(sales) OVER(
    ORDER BY month
  ) AS 'running_total'
FROM monthly_sales;`,
  lang: 'sql',
}

const task3: Task = {
  id: 'sql-aggregate-functions',
  categoryId: '6',
  title: 'aggregate functions',
  code: `SELECT year,
  COUNT(*)
FROM movies
GROUP BY year
HAVING COUNT(*) > 5;

SELECT AVG(salary)
FROM employees
WHERE experience < 5;`,
  lang: 'sql',
}

const task4: Task = {
  id: 'sql-case-command',
  categoryId: '6',
  title: 'case command',
  code: `SELECT student_name AS 'Student',
  overall_gpa AS 'GPA',
CASE
  WHEN overall_gpa > 3.0 THEN "Exceptional grades!"
  WHEN overall_gpa BETWEEN 2.0 AND 3.0 THEN "Good job!"
  ELSE "You're at risk of academic probation"
END
FROM students;`,
  lang: 'sql',
}

const task5: Task = {
  id: 'sql-create-view',
  categoryId: '6',
  title: 'create view',
  code: `CREATE VIEW student_count_by_country
AS
SELECT COUNT(student_name) AS student_count,
  birth_country
FROM students
GROUP BY birth_country`,
  lang: 'sql',
}

const task7: Task = {
  id: 'sql-constraints',
  categoryId: '6',
  title: 'constraints',
  code: `CREATE TABLE celebs (
  id INTEGER PRIMARY KEY,
  name TEXT UNIQUE,
  grade INTEGER NOT NULL,
  age INTEGER DEFAULT 10
);`,
  lang: 'sql',
}

const task8: Task = {
  id: 'sql-dates',
  categoryId: '6',
  title: 'dates',
  code: `SELECT DATE(order_date),
  COUNT(*) AS 'count_baked_goods'
FROM bodega
GROUP BY DATE(order_date);

SELECT TIME(order_date)
FROM bodega;`,
  lang: 'sql',
}

const task9: Task = {
  id: 'sql-join',
  categoryId: '6',
  title: 'join',
  code: `SELECT *
FROM books
INNER JOIN authors
  ON books.author_id = authors.id;

SELECT name
FROM first_names
UNION
SELECT name
FROM last_names;`,
  lang: 'sql',
}

const task10: Task = {
  id: 'sql-primary-keys',
  categoryId: '6',
  title: 'primary keys',
  code: `CREATE TABLE orders (
  order_id INTEGER NOT NULL,
  total_cost FLOAT
  purchase_date DATE
  PRIMARY KEY (order_id)
  FOREIGN KEY (customer_id) REFERENCES customers(customer_id)
);`,
  lang: 'sql',
}

const task11: Task = {
  id: 'sql-procedures',
  categoryId: '6',
  title: 'procedures',
  code: `DELIMITER

CREATE PROCEDURE add_int (IN x INT, IN y INT, OUT z INT)
BEGIN
  SELECT x + y INTO z;
END

DELIMITER ;

CALL add_int (5, 3, @z);
SELECT @z AS Result;`,
  lang: 'sql',
}

const task12: Task = {
  id: 'sql-with',
  categoryId: '6',
  title: 'with',
  code: `WITH temporary_name AS (
  SELECT *
  FROM table_name
)
SELECT *
FROM temporary_name
WHERE condition;`,
  lang: 'sql',
}

const task13: Task = {
  id: 'sql-union',
  categoryId: '6',
  title: 'union',
  code: `SELECT first_name, last_name, final_grade
FROM students_term_one
UNION
SELECT first_name, last_name, final_grade
FROM students_term_two;`,
  lang: 'sql',
}

export const SQLTasks: Task[] = [
  task1,
  task2,
  task3,
  task4,
  task5,
  task7,
  task8,
  task9,
  task10,
  task11,
  task12,
  task13,
]
